// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"bda2b2a2","121":"94224a5c","126":"8e59840d","129":"c77c84c6","163":"e046aa90","251":"21917af0","391":"b6bf43b1","420":"d6af57aa","571":"cdc19711","606":"1b2a2b08","693":"5a3378c7","767":"b1a5ec9c","916":"399e34e5"}[chunkId] + ".chunk.js";
};